import { cn } from "@/lib/utils"

interface GlassPanelProps extends React.ComponentProps<"div"> {
  intensity?: "low" | "medium" | "high"
  hover?: boolean
}

const intensityMap = {
  low: "bg-background/40 backdrop-blur-sm border-border/20",
  medium: "bg-background/50 backdrop-blur-md border-border/30",
  high: "bg-background/60 backdrop-blur-xl border-border/40",
}

function GlassPanel({
  className,
  intensity = "medium",
  hover = false,
  children,
  ...props
}: GlassPanelProps) {
  return (
    <div
      data-slot="glass-panel"
      className={cn(
        "rounded-xl border shadow-sm",
        intensityMap[intensity],
        hover && "transition-all duration-300 hover:shadow-md hover:border-border/50 hover:-translate-y-0.5",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export { GlassPanel }
